import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "chatter-9671a.firebaseapp.com",
  projectId: "chatter-9671a",
  storageBucket: "chatter-9671a.appspot.com",
  messagingSenderId: "534157112731",
  appId: "1:534157112731:web:3964cf075c519e026c9d3e",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage();
export const db = getFirestore();
export const auth = getAuth();
